import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import type { EmpresaCardData } from '@/services/marketplace.service';

function inicial(nome: string) { return (nome?.trim()?.[0] ?? '?').toUpperCase(); }

export function EmpresaCard({ empresa }: { empresa: EmpresaCardData }) {
  return (
    <Link to={`/empresas/${empresa.id}`} className="ow-card p-4 flex flex-col gap-3 hover:border-primary transition-colors">
      <div className="flex items-center gap-3">
        {empresa.logo_url
          ? <img src={empresa.logo_url} alt="" className="h-12 w-12 rounded-lg object-cover" />
          : <div className="h-12 w-12 rounded-lg bg-muted flex items-center justify-center font-bold">{inicial(empresa.nome)}</div>}
        <div className="min-w-0">
          <div className="font-bold truncate">{empresa.nome}</div>
          {empresa.rating_total > 0 && (
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Star className="h-3 w-3 fill-current" /> {empresa.rating_media} · {empresa.rating_total}
            </div>
          )}
        </div>
      </div>
      {empresa.categorias.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {empresa.categorias.map((c) => <span key={c.slug} className="status-pill text-xs">{c.nome}</span>)}
        </div>
      )}
      {empresa.cidades.length > 0 && (
        <div className="text-xs text-muted-foreground truncate">{empresa.cidades.join(' · ')}</div>
      )}
    </Link>
  );
}
